import {
  columnDefs as userReportsColumnDefs,
  columnDefsFunctions as userReportsColumnDefsFns,
} from "../../apps/users/UserReportsConstants";
import {
  columnDefs as productReportsColumnDefs,
  columnDefsFunctions as productReportsColumnDefsFns,
} from "../../apps/products/ProductsConstants";
import { columnDefs as customerReportsColumnDefs } from "../../apps/customer/CustomersConstants";
import { columnDefsFunctions as customerReportColumnDefsFns } from "../../apps/customer/CustomersConstants";
import { columnDefs as retailerRportsColumnDefs } from "../../apps/retailer/RetailerReportsConstants";
import {
  columnDefs as bankReportsColumnDefs,
  columnDefsFunctions as bankReportsColumnDefsFns,
} from "../../apps/bank/BanksConstants";
import { columnDefs as hsnReportsColumnDefs } from "../../apps/hsn/HsnConstants";
import {
  columnDefs as entityReportsColumnDefs,
  columnDefsFunctions as entityReportsColumnDefsFns,
} from "../../apps/entity/EntityConstants";

import {
  columnDefs as doctorReportsColumnDefs,
  columnDefsFunctions as doctorReportsColumnDefsFns,
} from "../../apps/doctor/DoctorConstants";

import {
  columnDefs as distributorReportsColumnDefs,
  columnDefsFunctions as distributorReportsColumnDefsFns,
} from "../../apps/distributor/DistributorConstants";

import {
  columnDefs as stockAuditReportsColumnDefs,
  columnDefsFunctions as stockAuditReportsColumnDefsFns,
} from "../../apps/stockAuditReport/StockAuditReportConstants";

import {
  columnDefs as stockTransferReportsColumnDefs,
  columnDefsFunctions as stockTransferReportsColumnDefsFns,
} from "../../apps/stockTransferReport/StockTransferReportConstants";

import {
  columnDefs as stockRequestReportsColumnDefs,
  columnDefsFunctions as stockRequestReportsColumnDefsFns,
} from "../../apps/stockRequestReport/StockRequestReportConstants";
import {
  columnDefs as professionMasterReportsColumnDefs,
  columnDefsFunctions as professionMasterReportsColumnDefsFns,
} from "../../apps/profession/ProfessionMasterReportsConstants";

import {
  columnDefs as specialityMasterReportsColumnDefs,
  columnDefsFunctions as specialityMasterReportsColumnDefsFns,
} from "../../apps/speciality/SpecialityMasterReportsConstants";

import {
  columnDefs as medicineWiseStockAuditReportsColumnDefs,
  columnDefsFunctions as medicineWiseStockAuditReportsColumnDefsFns,
} from "../../apps/medicineWiseStockAuditReport/MedicineWiseStockAuditReportConstants";
import {
  columnDefs as transportReportsColumnsDefs,
  columnDefsFunctions as transportReportsColumnsDefsFns,
} from "../../apps/transport/TransportConstants";

import {
  columnDefs as medicineWiseStockTransferReportsColumnDefs,
  columnDefsFunctions as medicineWiseStockTransferReportsColumnDefsFns,
} from "../../apps/medicineWiseStockTransferReport/MedicineWiseStockTransferReportConstants";

import {
  columnDefs as medicineWiseStockRequestReportsColumnDefs,
  columnDefsFunctions as medicineWiseStockRequestReportsColumnDefsFns,
} from "../../apps/medicineWiseStockRequestReport/MedicineWiseStockRequestReportConstants";

import {
  columnDefs as serviceItemMasterColumnDefs,
  columnDefsFunctions as serviceItemMasterColumnDefsFns,
} from "../../apps/serviceItems/ServiceItemConstants";

import {
  columnDefs as discountSlabReportsColumnDefs,
  columnDefsFunctions as discountSlabReportsColumnDefsFns,
} from "../../apps/discountSlabReport/DiscountSlabReportConstants";

import {
  columnDefs as discountProgramReportsColumnDefs,
  columnDefsFunctions as discountProgramReportsColumnDefsFns,
} from "../../apps/discountProgramReport/DiscountProgramReportConstants";

import {
  columnDefs as manufacturerMasterColumnDefs,
  columnDefsFunctions as manufacturerMasterColumnDefsFns,
} from "../../apps/manufacturer/ManufacturerConstants";

import {
  columnDefs as manufacturerGroupColumnDefs,
  columnDefsFunctions as manufacturerGroupColumnDefsFns,
} from "../../apps/manufacturerGroup/ManufacturerGroupConstants";

import {
  columnDefs as branchGroupColumnDefs,
  columnDefsFunctions as branchGroupColumnDefsFns,
} from "../../apps/branchGroup/BranchGroupConstants";

import {
  columnDefs as frequencySlabReportColumnDefs,
  columnDefsFunctions as frequencySlabReportColumnDefsFns,
} from "../../apps/frequencySlabReport/FrequencySlabReportConstants";

import {
  columnDefs as cacUserColumnDefs,
  columnDefsFunctions as cacUserColumnDefsFns,
} from "../../apps/cacUser/CacUserConstants";

import {
  columnDefs as doctorCommissionProgramReportsColumnDefs,
  columnDefsFunctions as doctorCommissionProgramReportsColumnDefsFns,
} from "../../apps/doctorCommissionProgramReport/DoctorCommissionProgramReportConstants";

import {
  columnDefs as modeConfigPricingReportsColumnDefs,
  columnDefsFunctions as modeConfigPricingReportsColumnDefsFns,
} from "../../apps/modeConfigPricing/ModeConfigPricingReportConstants";

import { isEmpty } from "../../utils/utils";

const COLUMN_DEFS = {
  user: {
    defs: userReportsColumnDefs,
    defs_fn: userReportsColumnDefsFns,
  },
  product: {
    defs: productReportsColumnDefs,
    defs_fn: productReportsColumnDefsFns,
  },
  customer: {
    defs: customerReportsColumnDefs,
    defs_fn: customerReportColumnDefsFns,
  },
  entity: {
    defs: entityReportsColumnDefs,
    defs_fn: entityReportsColumnDefsFns,
  },
  branch: {
    defs: retailerRportsColumnDefs,
    // defs_fn: retailerReportsColumnDefsFns,
  },
  bank: {
    defs: bankReportsColumnDefs,
    defs_fn: bankReportsColumnDefsFns,
  },
  doctor: {
    defs: doctorReportsColumnDefs,
    defs_fn: doctorReportsColumnDefsFns,
  },
  hsn: {
    defs: hsnReportsColumnDefs,
  },
  distributor: {
    defs: distributorReportsColumnDefs,
    defs_fn: distributorReportsColumnDefsFns,
  },
  stockAuditReport: {
    defs: stockAuditReportsColumnDefs,
    defs_fn: stockAuditReportsColumnDefsFns,
  },
  stockTransferReport: {
    defs: stockTransferReportsColumnDefs,
    defs_fn: stockTransferReportsColumnDefsFns,
  },
  stockRequestReport: {
    defs: stockRequestReportsColumnDefs,
    defs_fn: stockRequestReportsColumnDefsFns,
  },
  medicineWiseStockAuditReport: {
    defs: medicineWiseStockAuditReportsColumnDefs,
    defs_fn: medicineWiseStockAuditReportsColumnDefsFns,
  },
  professionMaster: {
    defs: professionMasterReportsColumnDefs,
    defs_fn: professionMasterReportsColumnDefsFns,
  },
  specialityMaster: {
    defs: specialityMasterReportsColumnDefs,
    defs_fn: specialityMasterReportsColumnDefsFns,
  },
  transport: {
    defs: transportReportsColumnsDefs,
    defs_fn: transportReportsColumnsDefsFns,
  },
  medicineWiseStockTransferReport: {
    defs: medicineWiseStockTransferReportsColumnDefs,
    defs_fn: medicineWiseStockTransferReportsColumnDefsFns,
  },
  medicineWiseStockRequestReport: {
    defs: medicineWiseStockRequestReportsColumnDefs,
    defs_fn: medicineWiseStockRequestReportsColumnDefsFns,
  },
  serviceItemMaster: {
    defs: serviceItemMasterColumnDefs,
    defs_fn: serviceItemMasterColumnDefsFns,
  },
  discountSlabReport: {
    defs: discountSlabReportsColumnDefs,
    defs_fn: discountSlabReportsColumnDefsFns,
  },
  discountProgramReport: {
    defs: discountProgramReportsColumnDefs,
    defs_fn: discountProgramReportsColumnDefsFns,
  },
  manufacturer: {
    defs: manufacturerMasterColumnDefs,
    defs_fn: manufacturerMasterColumnDefsFns,
  },
  manufacturerGroup: {
    defs: manufacturerGroupColumnDefs,
    defs_fn: manufacturerGroupColumnDefsFns,
  },
  branchGroup: {
    defs: branchGroupColumnDefs,
    defs_fn: branchGroupColumnDefsFns,
  },
  frequencySlabReport: {
    defs: frequencySlabReportColumnDefs,
    defs_fn: frequencySlabReportColumnDefsFns,
  },
  cacUser: {
    defs: cacUserColumnDefs,
    defs_fn: cacUserColumnDefsFns,
  },
  doctorCommissionProgramReport: {
    defs: doctorCommissionProgramReportsColumnDefs,
    defs_fn: doctorCommissionProgramReportsColumnDefsFns,
  },
  modeConfigPricingReport: {
    defs: modeConfigPricingReportsColumnDefs,
    defs_fn: modeConfigPricingReportsColumnDefsFns,
  },
};

export const fetchColumnDefs = (identifier) => {
  return COLUMN_DEFS[identifier]?.defs;
};

export const fetchColumnDefsFns = (identifier) => {
  return COLUMN_DEFS[identifier]?.defs_fn || [];
};

export const createFilterParam = (
  fieldName,
  fieldValue,
  fieldType,
  operation
) => {
  if (isEmpty(fieldName) || isEmpty(fieldValue)) {
    console.error("fieldName or fieldValue is empty");
    return null;
  }
  let param = { fieldName };
  if (fieldType) {
    param = { ...param, fieldType: { type: fieldType, operation } };
    if (operation === "between") {
      if (!fieldValue?.start || !fieldValue?.end) {
        console.error(
          "start and end in fieldValue is mandatory when operation is between"
        );
        return null;
      }
      param = { ...param, start: fieldValue.start, end: fieldValue.end };
      return param;
    }
  }
  param = { ...param, fieldValue };
  return param;
};
